<template>
  <v-app id="requisitoTramite">
    <v-content>
      <v-container grid-list-lg fluid>
        <v-layout row wrap>
          <v-flex xs12 class="py-0">
            <h4 class="grey--text text--darken-1">
              <v-icon small color="primary">drag_indicator</v-icon> Requisitos para Trámites
            </h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <!-- <v-card-title>
                <h4 class="grey--text text--darken-1">
                  Buscar Centro de Capacitación
                </h4>
              </v-card-title>
              <v-divider></v-divider> -->
              <v-card-text align-center>
                <!-- <pdf src="/resource/document.pdf" :page="1"></pdf> -->
                <!-- <pdf src="/resource/document.pdf">
                  <template slot="loading" align-center>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    Cargando...
                  </template>
                </pdf> -->
                <object
                  data="/resource/document.pdf"
                  width="100%"
                  height="100%"
                  type="application/pdf"
                  style="height: 80vh"
                >
                  El archivo no visualizado
                </object>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
      <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>
<script>
export default {
  name: 'requisito-tramite',
  components: {
    // pdf
  },
  data: () => ({
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    },
    message: ""
  }),
  mounted() {
  },
  methods: {
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>